import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';

import { SessionStore } from '../store/session.store';
import { HoldingCompany as Tenant } from '../features/shared/models/HoldingCompany';

export const TenantGuard: CanActivateFn = (route, state) => {
	const store = inject(SessionStore);
	const router = inject(Router);

	const requestedTenant = route.params['tenant'];
	const previousTenant = store.tenant()?.slug ?? store.tenant();

	return toObservable(store.tenants).pipe(
		filter((tenants: Tenant[]) => tenants.length > 0),
		take(1),
		map((tenants: Tenant[]) => {
			if (requestedTenant === 'network') {
				if (previousTenant && tenants.some((t) => t.slug === previousTenant)) {
					const newUrl = state.url.replace(/^\/network(\/|$)/, `/${previousTenant}$1`);
					return router.parseUrl(newUrl);
				} else {
					const defaultTenant = tenants[0];
					return router.createUrlTree(['/', defaultTenant.slug, 'dashboard']);
				}
			}

			if (requestedTenant && tenants.some((t) => t.slug === requestedTenant)) {
				return true;
			}

			if (previousTenant && tenants.some((t) => t.slug === previousTenant)) {
				return router.parseUrl(`/${previousTenant}/dashboard`);
			}

			const defaultTenant = tenants[0];
			return router.createUrlTree(['/', defaultTenant.slug, 'dashboard']);
		}),
	);
};
